import { IonButton, IonIcon, useIonAlert } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { sendOutline } from "ionicons/icons";
import { sendPeopleNotifications } from "../../../store/MassNotification/actions/sendPeopleNotifications";

const textStyle = {
  paddingLeft: 5,
};

export const ConfirmButton = () => {
  const dispatch = useDispatch();
  const [present] = useIonAlert();
  const state = useSelector((state: RootState) => state.massNotification);

  const onSubmit = async () => {
    dispatch(sendPeopleNotifications());
  };

  return (
    <>
      <IonButton
        fill="solid"
        size="large"
        color="secondary"
        disabled={
          (!state.email && !state.whatsapp) ||
          state.sendPeopleNotificationStatus === "pending" ||
          state.selectedPeople.length === 0
        }
        onClick={() => {
          present({
            header: `¿Deseas enviar notificaciones a ${state.selectedPeople.length} ${
              state.selectedPeople.length === 1 ? "persona" : "personas"
            }?`,
            buttons: [
              "No",
              {
                text: `Enviar notificaciones`,
                handler: () => onSubmit(),
              },
            ],
          });
        }}
      >
        Enviar{" "}
        <span style={textStyle} className="ion-hide-md-down">
          notificaciones
        </span>
        <IonIcon icon={sendOutline} style={textStyle} className="ion-hide-md-up" />
      </IonButton>
    </>
  );
};
